import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Payload } from './fiscalYearCabinet.model';
import { Cabinet } from '../cabinet/cabinet.model';
import fiscalYearCabinetService from './fiscalYearCabinet.service';

// namespace
export const FISCALYEAR_CABINET_STORE_NAMESPACE = 'fiscalYearCabinetStore';

// state
interface FiscalYearCabinetState {
  cabinets: Cabinet[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: FiscalYearCabinetState = {
  cabinets: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<FiscalYearCabinetState> = {
  [mutationConstant.FETCH]: (state: FiscalYearCabinetState, cabinets: Cabinet[]) => {
    state.cabinets = cabinets;
  },
  [mutationConstant.PENDING]: (state: FiscalYearCabinetState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: FiscalYearCabinetState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: FiscalYearCabinetState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<FiscalYearCabinetState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<FiscalYearCabinetState, RootState>, payload: Payload) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      fiscalYearCabinetService.Fetch(payload.fiscalYearId)
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<FiscalYearCabinetState, RootState> = {
  [getterConstant.ALL]: (state: FiscalYearCabinetState) => state.cabinets,
  [getterConstant.BY_ID]: (state: FiscalYearCabinetState) => (id: number) => state.cabinets.find(m => m.id === id),
  [getterConstant.STATUS]: (state: FiscalYearCabinetState) => state.status,
};

// module
const module: Module<FiscalYearCabinetState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const FiscalYearCabinetGetter = {
  ALL: `${FISCALYEAR_CABINET_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${FISCALYEAR_CABINET_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${FISCALYEAR_CABINET_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const FiscalYearCabinetAction = {
  FETCH: `${FISCALYEAR_CABINET_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
